import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const DEFAULT = { percent: 2.0, fixed: 0.0, label: "Card processing fee (2%)", enabled: true };

/**
 * Returns the live Stripe surcharge config from CMS plus a helper to apply it.
 *
 *  const { cfg, apply } = useSurcharge();
 *  const { subtotal, surcharge, total } = apply(98); // → { 98, 1.96, 99.96 }
 */
export default function useSurcharge() {
 const [cfg, setCfg] = useState(DEFAULT);

 useEffect(() => {
  let cancelled = false;
  axios.get(`${API}/api/cms/surcharge`)
   .then(r => { if (!cancelled && r?.data) setCfg(r.data); })
   .catch(() => { /* keep DEFAULT */ });
  return () => { cancelled = true; };
 }, []);

 const apply = (subtotal) => {
  const sub = Number(subtotal) || 0;
  if (!cfg.enabled) return { subtotal: sub, surcharge: 0, total: sub };
  const surcharge = Math.round((sub * (cfg.percent / 100) + (cfg.fixed || 0)) * 100) / 100;
  const total = Math.round((sub + surcharge) * 100) / 100;
  return { subtotal: sub, surcharge, total };
 };

 return { cfg, apply };
}
